import {
  InputChangeEvent,
  InputProps as KendInputProps,
  Input as KendoInput,
} from '@progress/kendo-react-inputs';
import _ from 'lodash';
import React, { forwardRef, Ref } from 'react';
import { ValidationError } from '../../apps/benefit/models/Errors';
import useToggleClass from '../hooks/useToggleClass';
import ErrorViewer from './ErrorViewer';

export interface InputProps {
  controlClassName?: string;
  mandatory?: boolean;
  helper?: string;
  onChange?: (e: InputChangeEvent) => void;
  errors?: ValidationError[];
  clearErrors?: () => void;
}

export default forwardRef(function Input(
  props: InputProps & KendInputProps,
  ref: Ref<HTMLElement | null>,
) {
  const inputRef = React.useRef<HTMLDivElement | null>(null);

  const { addClass, removeClass } = useToggleClass();
  const {
    controlClassName,
    mandatory,
    helper,
    id,
    label,
    errors,
    onChange,
    clearErrors,
  } = props;

  const internalOnChange = (e: InputChangeEvent) => {
    if (errors?.length) {
      clearErrors?.();
    }
    onChange?.(e);
  };

  const classNames = `control-group ${controlClassName ?? ''}`.trim();

  React.useEffect(() => {
    errors && errors?.length > 0
      ? addClass('control-error', inputRef)
      : removeClass('control-error', inputRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  return (
    <div className={classNames} ref={inputRef}>
      <div className="control-content">
        {!!label && (
          <label htmlFor={id}>
            {label}
            {mandatory && <sup>*</sup>}
          </label>
        )}

        <KendoInput
          {..._.omit(props, [
            'label',
            'mandatory',
            'clearErrors',
            'controlClassName',
          ])}
          id={id}
          onChange={internalOnChange}
          ref={ref}
        />
      </div>
      {!!helper && <div className="control-info">{helper}</div>}
      <ErrorViewer errors={errors} />
    </div>
  );
});
